<template>
  <div class="main-layout">
    <Navbar />
    <router-view />
  </div>
</template>

<script>

import Navbar from "@/components/Navbar.vue"

export default {
  name: "Main",
  components: {
    Navbar
  }
};

</script>

<style>

#app {
    margin-top: 0px;
}

</style>